module.exports = __webpack_public_path__ + "img/22.82bf9543.jpg";